import {
  actionTypes,
} from '../actions';

const initialState: any = {
  plans: [],
  invoices: [],
  transactions: [],
  currentCustomer: {},
  lastFailedInvoice: {},
  setupIntent: {},
  setPlanState: 'none',
  updateSubscriptionState: 'none',
  addCardState: 'none',
  getPlansState: 'none',
  cancelPlanState: 'none',
  deleteCardState: 'none',
  getCustomerState: 'none',
  setupIntentState: 'none',
  setDefaultCardState: 'none',
  paymentAttemptState: 'none',
  getTransactionsState: 'none',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PAYMENT_STATE: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case actionTypes.SET_SUBSCRIPTION:
      return {
        ...state,
        currentCustomer: {
          ...state.currentCustomer,
          subscriptions: {
            ...state.currentCustomer?.subscriptions || {},
            data: [
              ...state.currentCustomer?.subscriptions?.data || [],
              action.payload.subscription,
            ],
          },
        },
      };

    case actionTypes.UPDATE_SUBSCRIPTION:
      return {
        ...state,
        currentCustomer: {
          ...state.currentCustomer,
          subscriptions: {
            ...state.currentCustomer.subscriptions,
            data: state.currentCustomer.subscriptions.data.map(
              item => (item.id === action.payload.subscription.id
                ? { ...item, ...action.payload.subscription }
                : item
              ),
            ),
          },
        },
      };

    case actionTypes.SET_DEFAULT_CARD:
      return {
        ...state,
        currentCustomer: {
          ...state.currentCustomer,
          default_source: action.payload,
        },
      };

    case actionTypes.ADD_CARD:
      return {
        ...state,
        currentCustomer: {
          ...state.currentCustomer,
          sources: {
            ...state.currentCustomer.sources,
            data: [
              ...state.currentCustomer.sources.data,
              action.payload,
            ],
          },
        },
      };

    case actionTypes.DELETE_CARD:
      return {
        ...state,
        currentCustomer: {
          ...state.currentCustomer,
          default_source: action.payload.defaultCardId,
          sources: {
            ...state.currentCustomer.sources,
            data: [
              ...state.currentCustomer.sources.data.filter(e => e.id !== action.payload.deletedId),
            ],
          },
        },
      };
    default:
      return state;
  }
};
